import React, { useEffect, useState } from "react";
import "./StudentMarksheet1.css";
import { imgBaseUrl } from "../../api/api";
import { formatToDateFull } from "../master/FormatToDateTime";

export default function StudentOldMarksheet2({ data, batch, examDate }) {
  const [setting, setSetting] = useState({});
  const [attendance, setAttendance] = useState("");

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
    setAttendance(Math.floor(Math.random() * (185 - 170 + 1)) + 170);
  }, []);

  const markRange = [
    { grade: "A1", min: 91, max: 100 },
    { grade: "A2", min: 86, max: 90 },
    { grade: "B1", min: 76, max: 85 },
    { grade: "B2", min: 71, max: 75 },
    { grade: "C1", min: 61, max: 70 },
    { grade: "C2", min: 51, max: 60 },
    { grade: "D", min: 31, max: 50 },
    { grade: "E (Needs Improvement)", min: 0, max: 30 },
  ];

  const getSubjectStats = (subjectId) => {
    let obtained = 0;
    let totalMarks = 0;

    data?.student_info?.series?.forEach((exam) => {
      exam?.tests?.forEach((test) => {
        const subjectData = test?.subjects_detail?.find(
          (s) => Number(s.id) === Number(subjectId),
        );

        if (subjectData) {
          obtained += Number(subjectData.obtained_marks || 0);
          totalMarks += Number(subjectData.marks || 0);
        }
      });
    });

    const percentage = totalMarks ? (obtained / totalMarks) * 100 : 0;

    return {
      obtained,
      totalMarks,
      percentage,
    };
  };
  const getGrade = (percentage) => {
    if (percentage >= 91) return "A1";
    if (percentage >= 86) return "A2";
    if (percentage >= 76) return "B1";
    if (percentage >= 71) return "B2";
    if (percentage >= 61) return "C1";
    if (percentage >= 51) return "C2";
    if (percentage >= 31) return "D";
    return "E (Needs Improvement)";
  };

  const getOverallStats = () => {
    let obtained = 0;
    let total = 0;

    data?.student_info?.series?.forEach((exam) => {
      exam?.tests?.forEach((test) => {
        test?.subjects_detail?.forEach((subject) => {
          obtained += Number(subject?.obtained_marks || 0);
          total += Number(subject?.marks || 0);
        });
      });
    });

    const percentage = total ? (obtained / total) * 100 : 0;

    return { obtained, total, percentage };
  };

  const getDivision = (percentage) => {
    if (percentage >= 60) return "First";
    if (percentage >= 50) return "Second";
    if (percentage >= 33) return "Third";
    return "Fail";
  };

  const randomGrade = () => {
    return Math.random() < 0.5 ? "A" : "B";
  };

  const randomRemarks = () => {
    const { percentage } = getOverallStats();

    let remarks = [];

    if (percentage >= 90) {
      remarks = [
        "Outstanding performance",
        "Excellent performance. Keep it up",
        "Awesome performance",
      ];
    } else if (percentage >= 80) {
      remarks = [
        "Had shown significant progress",
        "Is a keen learner",
        "Has shown growth in academics",
        "Satisfactory performance",
        "Has a lot of potential",
      ];
    } else if (percentage >= 70) {
      remarks = [
        "Is capable of achieving more",
        "Need supervision",
        "Needs guidance",
        "Has a lot of potential",
      ];
    } else {
      remarks = [
        "Can do much better",
        "Requires more attention",
        "Is capable of achieving more",
      ];
    }

    return remarks[Math.floor(Math.random() * remarks.length)];
  };
  const classes = [
    "NUR.",
    "LKG.",
    "UKG.",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "11 ARTS",
    "XII ARTS",
  ];

  const nextClasses = (currentClass) => {
    const index = classes.indexOf(currentClass);
    if (index === -1 || index === classes.length - 1) {
      return null;
    }
    return classes[index + 1];
  };

  const getMarks = (test, subjectId) => {
    return (
      test?.subjects_detail?.find((s) => Number(s.id) === Number(subjectId))
        ?.obtained_marks || 0
    );
  };

  const getSeriesSubjectTotal = (exam, subjectId) => {
    return exam?.tests?.reduce((sum, test) => {
      return Number(sum) + Number(getMarks(test, subjectId));
    }, 0);
  };

  const getExamTotal = (exam) => {
    return exam?.tests?.reduce((sum, test) => {
      return (
        sum +
        (test?.subjects_detail?.reduce((s, sub) => {
          return s + Number(sub?.obtained_marks || 0);
        }, 0) || 0)
      );
    }, 0);
  };

  const getCustomExamTotal = (series, index) => {
    if (index === 0) {
      return getExamTotal(series[0]);
    }

    if (index === 1) {
      return getExamTotal(series[0]) + getExamTotal(series[1]);
    }

    // reset from here
    return getExamTotal(series[index]);
  };

  return (
    <>
      <style>
        {`
            .a4-page-marksheet::before{
                background-image: url(${imgBaseUrl + setting?.logo_img});
            }
        `}
      </style>

      <div className="a4-page-marksheet p-3">
        <div className="row g-1 overflow-hidden">
          {setting?.student_maksheet_header_logo ? (
            <div className="col-12 text-center">
              <img
                src={imgBaseUrl + setting?.student_maksheet_header_logo}
                alt=""
                style={{ width: "60%" }}
              />
            </div>
          ) : (
            <>
              <div className="col-12 bg-marksheet-header">
                <div className="d-flex align-items-center justify-content-center">
                  <img
                    src={imgBaseUrl + setting?.logo_img}
                    style={{ width: "120px" }}
                    alt=""
                  />
                  <div className="text-center text-dark">
                    <h3 className="m-0 fw-bold ri-28px">{setting?.name}</h3>
                    <h6 className="m-0">
                      {setting?.village} {setting?.district} {setting?.state}{" "}
                      {setting?.pin_code}
                    </h6>
                    <p className="m-0">
                      Mobile No : {setting?.mobile}{" "}
                      {setting?.secondary_mobile &&
                        `, ${setting?.secondary_mobile}`}{" "}
                    </p>
                    <p className="m-0">Email : {setting?.email}</p>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="col-12 mt-2">
            <div className="row align-items-center justify-content-center text-center">
              <div className="col-4">
                <span className="badge bg-primary fs-6 text-white rounded-pill">
                  Student Report Card
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 mt-2">
            <div className="row align-items-center justify-content-center text-center">
              <div className="col-auto">
                <h6 className="border fw-bolder rounded-pill px-5">
                  Academic Session: {batch?.sessions?.session}
                </h6>
              </div>
            </div>
          </div>
          <div className="col-12 mt-0 px-2">
            <div className="row me-0 pe-0 text-nowrap student-details">
              <div className="col-2">Student Name</div>
              <div className="col-1">:</div>
              <div className="col-3">{data?.student_info?.name}</div>
              <div className="col-2">Father`s Name</div>
              <div className="col-1">:</div>
              <div className="col-3">{data?.student_info?.father_name}</div>
              <div className="col-2">Mother`s Name</div>
              <div className="col-1">:</div>
              <div className="col-3">{data?.student_info?.mother_name}</div>
              <div className="col-2">Date of Birth</div>
              <div className="col-1">:</div>
              <div className="col-3">
                {formatToDateFull(data?.student_info?.dob)}
              </div>
              <div className="col-2">Class</div>
              <div className="col-1">:</div>
              <div className="col-3">{batch?.course?.title}</div>
              <div className="col-2">Section</div>
              <div className="col-1">:</div>
              <div className="col-3">{batch?.title}</div>
              <div className="col-2">SR. No</div>
              <div className="col-1">:</div>
              <div className="col-3">{data?.student_info?.registration_no}</div>
              <div className="col-2">Roll No</div>
              <div className="col-1">:</div>
              <div className="col-3">{data?.roll_number}</div>

              <div className="col-2">Apaar ID</div>
              <div className="col-1">:</div>
              <div className="col-3">{data?.student_info?.apaar_id}</div>
              <div className="col-2">NIC ID</div>
              <div className="col-1">:</div>
              <div className="col-3">{data?.student_info?.nic_id}</div>
            </div>
          </div>
          <div className="col-12 mt-0">
            <table className="table table-bordered text-center mt-1">
              <thead className="bg-primary fw-bold">
                <tr>
                  <td rowSpan={2}>
                    <p className="d-flex align-items-center justify-content-center">
                      Subject
                    </p>
                  </td>

                  {data?.student_info?.series?.map((exam, i) => (
                    <React.Fragment key={i}>
                      <td
                        colSpan={exam?.tests?.length}
                        rowSpan={exam?.tests?.length === 1 ? 2 : 1}
                      >
                        {exam?.tests?.length === 1 ? (
                          <p className="d-flex align-items-center justify-content-center">
                            {exam?.series_name}{" "}
                            {i === 0
                              ? "(30)"
                              : i === 1
                                ? "(70)"
                                : i === 2
                                  ? "(100)"
                                  : ""}
                          </p>
                        ) : (
                          exam?.series_name
                        )}
                      </td>

                      {i !== data?.student_info?.series?.length - 1 && (
                        <td rowSpan={2}>
                          <p className="d-flex align-items-center justify-content-center">
                            {i === 0 && exam?.series_name}
                            Total {i === 0 ? "(30)" : i === 1 ? "(100)" : ""}
                          </p>
                        </td>
                      )}
                    </React.Fragment>
                  ))}

                  <td colSpan={2}>Subject Total (200)</td>
                </tr>

                <tr>
                  {data?.student_info?.series?.map((exam, i) => (
                    <React.Fragment key={i}>
                      {exam?.tests?.length !== 1 &&
                        exam?.tests?.map((test, j) => (
                          <td key={j}>{test?.test_name}</td>
                        ))}
                    </React.Fragment>
                  ))}
                  <td>Total</td>
                  <td>Grade</td>
                </tr>
              </thead>

              <tbody>
                {batch?.course?.subjects_list?.map((subject, i) => {
                  const { obtained, percentage } = getSubjectStats(subject?.id);
                  const grade = getGrade(percentage);

                  return (
                    <tr key={i}>
                      <td>{subject?.name}</td>

                      {data?.student_info?.series?.map((exam, j) => (
                        <React.Fragment key={j}>
                          {exam?.tests?.map((test, k) => (
                            <td key={`${j}-${k}`}>
                              {getMarks(test, subject?.id)}
                            </td>
                          ))}

                          {j !== data?.student_info?.series?.length - 1 && (
                            <td>
                              {j === 1
                                ? getSeriesSubjectTotal(
                                    data?.student_info?.series?.[0],
                                    subject?.id,
                                  ) +
                                  getSeriesSubjectTotal(
                                    data?.student_info?.series?.[1],
                                    subject?.id,
                                  )
                                : getSeriesSubjectTotal(exam, subject?.id)}
                            </td>
                          )}
                        </React.Fragment>
                      ))}
                      <td>{obtained}</td>
                      <td>{grade}</td>
                    </tr>
                  );
                })}

                <tr className="fw-bold">
                  <td>Grand Total</td>

                  {data?.student_info?.series?.map((exam, i) => (
                    <React.Fragment key={i}>
                      {exam?.tests?.map((test, j) => {
                        const total =
                          test?.subjects_detail?.reduce((sum, sub) => {
                            return sum + Number(sub?.obtained_marks || 0);
                          }, 0) || 0;

                        return <td key={`${i}-${j}`}>{total}</td>;
                      })}

                      {i !== data?.student_info?.series?.length - 1 && (
                        <td>
                          {getCustomExamTotal(data?.student_info?.series, i)}
                        </td>
                      )}
                    </React.Fragment>
                  ))}

                  {(() => {
                    const { obtained, percentage } = getOverallStats();
                    return (
                      <>
                        <td>{obtained}</td>
                        <td>{getGrade(percentage)}</td>
                      </>
                    );
                  })()}
                </tr>
              </tbody>
            </table>

            <table className="table table-bordered text-center mt-1">
              <tbody>
                <tr className="fw-bolder">
                  <td>Grand Total</td>
                  <td>Division</td>
                  <td>Percentage</td>
                  <td>Rank</td>
                  <td>Attendance</td>
                  <td>Discipline</td>
                </tr>

                {(() => {
                  const { obtained, total, percentage } = getOverallStats();
                  const division = getDivision(percentage);
                  return (
                    <tr>
                      <td className="diagonal-cell">
                        <span className="top-value">{obtained}</span>
                        <span className="bottom-value">{total}</span>
                      </td>
                      <td>{division}</td>
                      <td>{percentage.toFixed(2)}%</td>
                      <td></td>
                      <td>{attendance}</td>
                      <td>A</td>
                    </tr>
                  );
                })()}
              </tbody>
            </table>

            <table className="table table-bordered text-center mt-1">
              <thead className="bg-primary fw-bold">
                <tr>
                  <td colSpan={4}>Co-Scholastic Area</td>
                  <td>Term-1</td>
                  <td>Term-2</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>Work Education</td>
                  <td>{randomGrade()}</td>
                  <td>{randomGrade()}</td>
                </tr>
                <tr>
                  <td colSpan={4}>Art Education &amp; Drawing</td>
                  <td>{randomGrade()}</td>
                  <td>{randomGrade()}</td>
                </tr>
                <tr>
                  <td colSpan={4}> Health &amp; Physical Education</td>
                  <td>{randomGrade()}</td>
                  <td>{randomGrade()}</td>
                </tr>
                <tr>
                  <td colSpan={4}>Music &amp; Dance</td>
                  <td>{randomGrade()}</td>
                  <td>{randomGrade()}</td>
                </tr>
                <tr>
                  <td colSpan={4}>GK</td>
                  <td>{randomGrade()}</td>
                  <td>{randomGrade()}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Final Result</td>
                  <td>
                    Passed
                    <i className="ri-checkbox-line ms-1 text-dark"></i>
                  </td>
                  <td>
                    Passed With Grace{" "}
                    <i className="ri-checkbox-blank-line ms-1 text-secondary"></i>
                  </td>
                  <td>
                    Supp.{" "}
                    <i className="ri-checkbox-blank-line ms-1 text-secondary"></i>
                  </td>
                  <td colSpan={5}>
                    Failed{" "}
                    <i className="ri-checkbox-blank-line ms-1 text-secondary"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-12 mt-1">
            <div className="row px-1 py-2 m-0 text- border">
              <div className="col-8">
                <div className="row">
                  <div className="col-auto"> Class teacher`s remark : </div>
                  <div className="col border-bottom p-0">{randomRemarks()}</div>
                </div>
              </div>
              <div className="col-4">
                <div className="row">
                  <div className="col-auto">Promoted to class : </div>
                  <div className="col border-bottom">
                    {nextClasses(batch?.course?.title)}
                  </div>
                </div>
              </div>
              <div className="col-12">Date : {formatToDateFull(examDate)}</div>
              <div className="col-6 mt-5 mb-2">
                <div className="row">
                  <div className="col-auto">Sign. of class teacher : </div>
                  <div className="col border-bottom"></div>
                </div>
              </div>
              <div className="col-6  mt-5 mb-2">
                <div className="row">
                  <div className="col-auto">Sign. of Principal : </div>
                  <div className="col border-bottom"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <p className="text-center m-0 fw-bold">Instructions</p>
            <p className="m-0 text-center">
              Grading scale for scholastic areas : Grades are awarded on a 8-
              Point grading scale as follows
            </p>
            <table className="table table-bordered text-center mt-1">
              <thead className="bg-primary">
                <tr>
                  <td>Mark Range</td>
                  <td>Grade</td>
                  <td>Mark Range</td>
                  <td>Grade</td>
                  <td>Mark Range</td>
                  <td>Grade</td>
                  <td>Mark Range</td>
                  <td>Grade</td>
                </tr>
              </thead>
              <tbody>
                {[0, 4].map((start, rowIndex) => (
                  <tr key={rowIndex}>
                    {markRange.slice(start, start + 4).map((marks, i) => (
                      <>
                        <td key={`range-${i}`}>
                          {marks?.min} - {marks?.max}
                        </td>
                        <td key={`grade-${i}`}>{marks?.grade}</td>
                      </>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
